// https://www.npmjs.com/package/react-devtools#usage-with-react-dom
// import "react-devtools"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import * as serviceWorker from "./serviceWorker"
import "./style/index.scss"
import { MsalProvider } from "@azure/msal-react"
import {
	publicClientApplication,
	scopes,
} from "./authentication/PublicClientApplication"
import { AccountInfo } from "@azure/msal-browser"
import { AuthenticationContext } from "./authentication/AuthenticationContext"
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { history } from "./applicationInsights/applicationInsights"
import Inventur from "./components/Inventur"

publicClientApplication.initialize().then(async () => {
	// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/v1-migration.md#3-update-your-code
	const authenticationResult = await publicClientApplication.handleRedirectPromise()

	let account: null | AccountInfo = null

	if (authenticationResult !== null) {
		account = authenticationResult.account
	} else {
		const accounts = publicClientApplication.getAllAccounts()

		if (accounts.length === 1
			&& accounts[0] !== undefined) {
			account = accounts[0]
		} else if (accounts.length === 0) {
			publicClientApplication.loginRedirect({ scopes })
		} else if (process.env.NODE_ENV === "development") {
			if (process.env.REACT_APP_MICROSOFT_IDENTITY_AUTHORITY === "imcfhkremsdev.onmicrosoft.com"
				&& accounts.some(s => s.username.endsWith("@imcfhkremsdev.onmicrosoft.com"))) {
				account = accounts.find(f => f.username.endsWith("@imcfhkremsdev.onmicrosoft.com"))!
			} else if (process.env.REACT_APP_MICROSOFT_IDENTITY_AUTHORITY === "imcfhkrems.onmicrosoft.com"
				&& accounts.some(s => !s.username.endsWith("@imcfhkremsdev.onmicrosoft.com"))) {
				account = accounts.find(f => !f.username.endsWith("@imcfhkremsdev.onmicrosoft.com"))!
			}
		}
	}

	const root = createRoot(document.getElementById("root")!)

	root.render(
		<StrictMode>
			<MsalProvider instance={publicClientApplication}>
				<AuthenticationContext.Provider value={{ accountInfo: account }}>
					<HistoryRouter history={history}>
						<Inventur />
					</HistoryRouter>
				</AuthenticationContext.Provider>
			</MsalProvider>
		</StrictMode>
	)
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
